import { useContext } from 'react';
import { UserActionTrackerContext } from './user-action-tracker-context';

export function useUserActionTracker() {
    return useContext(UserActionTrackerContext);
}
